import { ID_RE } from 'mk2/helpers/urls';

const ORDER_ID = `:orderId(${ID_RE})`;
const TESTING_ID = `:testingId(${ID_RE})`;
const ORDER_ITEM_ID = `:orderItemId(${ID_RE})`;
const ATTACHMENT_ID = `:attachmentId(${ID_RE})`;

export const boUrl = '/bo/';
export const boBankPaymentsUrl = '/bo/bank-payments/';
export const boPaymentOrdersUrl = '/bo/bank-payment-orders/';
export const boCommentsSnapUrl = '/bo/orders/comments-snap/';
export const boOrdersUrl = '/bo/orders/';
export const boOrdersAttachmentUrl = `/bo/orders-dj/attachment/${ATTACHMENT_ID}/`;
export const boOrdersChartUrl = '/bo/orders/chart/';
export const boOrderCreateUrl = '/bo/orders/create/';
export const boOrdersDetailUrl = `/bo/orders/${ORDER_ID}/`;
export const boOrdersEditUrl = `/bo/orders/${ORDER_ID}/edit/`;
export const boOrdersHistoryUrl = `/bo/orders/${ORDER_ID}/history/`;
export const boOrdersProductsUrl = '/bo/orders/products/';
export const boOrdersReportTestingUrl = `/bo/orders/report/${ORDER_ID}/testing/${ORDER_ITEM_ID}/`;
export const boOrdersReportAmbassadorUrl = `/bo/orders/report/${ORDER_ID}/ambassador/${ORDER_ITEM_ID}/:yearMonth([0-9]+)/`;
export const boOrdersReportUrl = `/bo/orders/report/${ORDER_ID}/`;
export const boOrdersSignedUrl = '/bo/orders/signed/';
export const boTestingsUrl = '/bo/testings/';
export const boTestingEditUrl = `/bo/testings/edit/${TESTING_ID}/`;
export const boTestingCreateUrl = `/bo/testings/new/`;
